export function computed<T>(fn: () => T): T {
    return fn();
}
